// Creator / author related utility helpers extracted from FullscreenPoiModal
// Pure functions — no React state.

export const extractCreatorId = (c: any): string | null => {
  try {
    if (!c) return null;
    if (c.card && typeof c.card === 'object') c = c.card; // unwrap common wrapper
    const candidates = ['creator_id', 'created_by', 'owner_id', 'user_id', 'creator', 'author_id', 'createdBy', 'creatorId', 'ownerId'];
    for (const k of candidates) {
      if (k in c && c[k]) return String(c[k]);
    }
    if (c.payload) {
      if (c.payload.creator_id) return String(c.payload.creator_id);
      if (c.payload.created_by) return String(c.payload.created_by);
    }
    if (c.rawMergedPayload) {
      if (c.rawMergedPayload.creator_id) return String(c.rawMergedPayload.creator_id);
      if (c.rawMergedPayload.created_by) return String(c.rawMergedPayload.created_by);
    }
    if (c.owner && (c.owner.id || c.owner.user_id)) return String(c.owner.id || c.owner.user_id);
    if (c.created && c.created.by) return String(c.created.by);
  } catch {}
  return null;
};

export const isValidId = (v: any): boolean => {
  if (v === null || typeof v === 'undefined') return false;
  const s = String(v).trim();
  if (!s) return false;
  const low = s.toLowerCase();
  return !(low === 'null' || low === 'undefined' || low === '0');
};

// Attempt to pick an embedded creator profile-like object and normalize it.
export const pickInlineCreator = (src: any, activeCardId?: string | null): null | {
  cardId?: string | null;
  id: string;
  display_name: string;
  avatar_url?: string;
  bio?: string;
} => {
  if (!src || typeof src !== 'object') return null;
  const candidateObjects = [
    src.creator,
    src.creator_profile,
    src.creatorProfile,
    src.owner,
    src.owner_profile,
    src.ownerProfile,
    src.created_by_profile,
    src.author,
    src.author_profile,
    src.user,
    src.profile,
  ];
  for (const candidate of candidateObjects) {
    if (!candidate || typeof candidate !== 'object') continue;
    const idCandidate = candidate.id || candidate.user_id || candidate.userId || candidate.uid;
    if (!idCandidate) continue;
    const displayName = candidate.display_name || candidate.nickname || candidate.name || candidate.username || candidate.full_name || candidate.fullName || 'Unknown User';
    const avatar = candidate.avatar_url || candidate.avatar || candidate.avatarUrl;
    const bio = candidate.bio || candidate.signature || candidate.description || candidate.tagline;
    return {
      cardId: activeCardId || null,
      id: String(idCandidate),
      display_name: displayName,
      avatar_url: avatar || undefined,
      bio: bio || undefined,
    };
  }
  if (src.creator_id && (src.creator_display_name || src.creatorDisplayName)) {
    return {
      cardId: activeCardId || null,
      id: String(src.creator_id),
      display_name: String(src.creator_display_name || src.creatorDisplayName),
      avatar_url: src.creator_avatar || src.creatorAvatar || undefined,
      bio: src.creator_bio || src.creatorBio || undefined,
    };
  }
  if (src.created_by && src.created_by_display_name) {
    return {
      cardId: activeCardId || null,
      id: String(src.created_by),
      display_name: String(src.created_by_display_name),
      avatar_url: src.created_by_avatar || undefined,
      bio: src.created_by_bio || undefined,
    };
  }
  return null;
};
